/* WEAVEPLACE — Product metafield/metaobject size guide, no external application. */
(() => {
  const columns = ['ES', 'EU', 'IT', 'UK', 'US'];
  function parseConversions(text) {
    const result = new Map();
    String(text || '').split(/\r?\n/).forEach(line => {
      const cells = line.trim().split('|').map(item => item.trim());
      if (cells[0]) result.set(cells[0].toUpperCase(), cells.slice(1));
    });
    return result;
  }
  function measure(value, unit) {
    if (unit === 'cm') return value;
    // Convert numeric bounds only. Non-numeric merchant labels remain unchanged.
    return String(value).replace(/\d+(?:[.,]\d+)?/g, match =>
      (Number(match.replace(',', '.')) / 2.54).toFixed(1)
    );
  }
  function setup(container) {
    if (container.dataset.wpSgReady) return;
    container.dataset.wpSgReady = '1';
    const conversions = parseConversions(container.dataset.conversions);
    const country = container.querySelector('[data-wp-sg-country]');
    const buttons = [...container.querySelectorAll('[data-wp-sg-unit]')];
    const units = [...container.querySelectorAll('[data-wp-sg-measure]')];
    const countryCells = [...container.querySelectorAll('[data-wp-sg-conversion]')];
    let current = 'cm';
    function render() {
      const col = columns.indexOf(country?.value || 'ES');
      countryCells.forEach(cell => {
        const row = conversions.get(cell.dataset.wpSgConversion.toUpperCase());
        cell.textContent = row?.[col] || '—';
      });
      units.forEach(cell => { cell.textContent = measure(cell.dataset.wpSgMeasure, current); });
      buttons.forEach(button => {
        const active = button.dataset.wpSgUnit === current;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
    country?.addEventListener('change', render);
    buttons.forEach(button => button.addEventListener('click', () => {
      current = button.dataset.wpSgUnit;
      render();
    }));
    render();
  }
  // The PDP copies <template> content into its drawer on every open.
  document.addEventListener('click', event => {
    if (!event.target.closest('weaveplace-product [data-modal="size"]')) return;
    requestAnimationFrame(() => document.querySelectorAll('.wp-pdp__drawer [data-wp-size-guide]').forEach(setup));
  });
  // Support other programmatic drawer opens and section reloads.
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.wp-pdp__drawer [data-wp-size-guide]:not([data-wp-sg-ready])').forEach(setup);
  });
  const start = () => observer.observe(document.body, {childList:true,subtree:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
